export default "dist/images/block-blog-posts-portfolio2.e58a6fb.png";